export const useContentRouteHelper = () => {
  const route = useRoute();

  const profile = useProfileStore();

  const { mainContent } = useContents();

  const { getIdFromSlug } = useContentsHelper();

  const isMainContentId = (id) => {
    return mainContent.value.id === id;
  };

  const libraryBookIdFromRoute = computed(() => {
    if (
      route.params.section !== Sections.ChildForYou &&
      route.params.lb_or_eval
    ) {
      return getIdFromSlug(route.params.lb_or_eval as string);
    } else {
      return mainContent.value.id;
    }
  });

  const isMainContentRoute = computed(() => {
    return isMainContentId(libraryBookIdFromRoute.value);
  });

  const contentUserTypeFromRoute = computed<
    ContentUserType.Default | ContentUserType.Child
  >(() => {
    const section = route.params.section as string;

    if (section && section === Sections.Revisions && profile.isParent) {
      return ContentUserType.Child;
    }
    return ContentUserType.Default;
  });

  const queryContentMemberId = computed(() => {
    return route.query.contentMemberId as string;
  });

  return {
    isMainContentRoute,
    libraryBookIdFromRoute,
    contentUserTypeFromRoute,
    queryContentMemberId,
  };
};
